<template>
  <div>
    <form class="row default-form add-payment-card m-0">
      <div class="form-group col-md-12">
        <label>
          {{ _T('Cardholder Name') }}
          <span>*</span>
        </label>
        <input
          v-model="cardModel.name"
          type="text"
          class="form-control"
          placeholder="John Doe"
          required
        />
        <span class="validation-error d-block pt-1" v-if="errors['name']">{{
          errors['name']
        }}</span>
      </div>
      <div class="form-group col-6">
        <label>
          {{ _T('Card Number') }}
          <span>*</span>
        </label>
        <input
          v-model="cardModel.number"
          class="form-control"
          type="text"
          maxlength="20"
          autocomplete="off"
          autofocus
          v-mask="{ mask: '9999-9999-9999-9999', greedy: true }"
          placeholder="____-____-____-____"
        />
        <span class="validation-error d-block pt-1" v-if="errors['number']">{{
          errors['number']
        }}</span>
      </div>
      <div class="form-group col-6">
        <label>
          CVC
          <span>*</span>
          <span>
            <img src="/images/checkout/question.png" alt />
          </span>
        </label>
        <input
          type="text"
          @keypress="cvcOnly"
          class="form-control"
          v-model="cardModel.cvc"
          maxlength="4"
          autocomplete="off"
          placeholder="123"
        />

        <span class="validation-error d-block pt-1" v-if="errors['cvc']">
          {{ errors['cvc'] }}
        </span>
      </div>
      <div class="form-group col-6">
        <label>{{ _T('Expiry Month') }}</label>
        <select v-model="cardModel.expMonth" class="form-control select-box">
          <option
            :key="'month_' + month.number"
            :value="month.number"
            v-for="month in months"
          >
            {{ month.title }}
          </option>
        </select>
        <span class="validation-error d-block pt-1" v-if="errors['expMonth']">{{
          errors['expMonth']
        }}</span>
      </div>
      <div class="form-group col-6">
        <label>{{ _T('Year') }}</label>

        <select v-model="cardModel.expYear" class="form-control select-box">
          <option
            :key="'year_' + year.number"
            :value="year.number"
            v-for="year in years"
            >{{ year.title }}</option
          >
        </select>
        <span class="validation-error d-block pt-1" v-if="errors['expYear']">{{
          errors['expYear']
        }}</span>
      </div>
    </form>
    <div class="chk-outline">
      <label>
        <input class="checkbox_animated" type="checkbox" v-model="saveCard" />
        {{ _T('Save card for future payments') }}
      </label>
    </div>

    <div class="text-right" v-if="confirmButton">
      <button type="button" class="btn btn-danger">Add Card</button>
    </div>
    <!-- <div class="modal-footer" v-if="confirmButton">
      <progress-bar
        v-if="processInProgress(process)"
        :btn-large="true"
      ></progress-bar>
      <button
        v-else
        type="button"
        class="btn btn-danger btn-block"
        data-dismiss="modal"
        :disabled="
          processInProgress('simplify_load') ||
            processInProgress('simplify_charge')
        "
        @click="send_trans"
      >
        {{ _T('Confirm') }}
      </button>
    </div>-->
  </div>
</template>
<script>
// import ProgressBar from '@/components/Elements/ProgressBar.vue'
import simplify from '@/mixins/simplify'
export default {
  name: 'CreditCardForm',
  // components: { ProgressBar },
  props: ['confirmButton'],
  mixins: [simplify],
  computed: {
    errors() {
      return this.$store.state.payment_store.cardErrors
    },
    saveCard: {
      get() {
        return this.$store.state.payment_store.isSaveCard
      },
      set(val) {
        this.$store.commit('IS_SAVE_CARD', val)
      },
    },
    cardModel: {
      get() {
        return this.$store.state.payment_store.cardModel
      },
      set(card) {
        this.$store.commit('SET_CARD_MODEL', card)
      },
    },
  },
  methods: {
    cvcOnly(event) {
      if (!event) {
        event = window.event
      }
      if (/\d/.test(event.key) && event.key >= 0 && event.key <= 9) { 
        return true
      } else {
        event.preventDefault()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// #addCard {
//   .modal-footer {
//     margin: 0 (-$px16) (-$px16);
//   }
// }
.add-payment-card {
  &.default-form {
    .form-group {
      label {
        line-height: $px16;
        letter-spacing: 0.02em;
        display: block;
        margin-left: 0 !important;
        span {
          float: unset;
          width: auto;
        }
      }
      input {
        line-height: $px17;
        letter-spacing: 0.02em;
        position: relative !important;
        top: unset !important;
      }
      .select-box {
        option {
          color: $primary-color;
          background-color: $white;
          padding: $px8 $px16 !important;
          font-size: $px18;
        }
        &:hover {
          border-color: $color-background-darken20;
        }
      }
    }
  }
}
.chk-outline {
  @media (max-width: 575px) {
    margin-left: $px16;
  }
  input {
    position: relative !important;
    top: unset !important;
  }
}
p {
  font-size: calc(12px + (14 - 12) * ((100vw - 320px) / (1920 - 320)));
  line-height: calc(15px + (22 - 15) * ((100vw - 320px) / (1920 - 320)));
  letter-spacing: 0.02em;
  color: $font-color;
}
</style>
